import { create } from "zustand";
import { agentActivityMessageTypes, agentActivityMessageVariableType, CommonResponseModel, OrganizationWabaVerificationData } from "../models/axiosModel";
import agent from "../services/api";

interface integrationStoreInterface {
    agentActivityMessageTypes: agentActivityMessageTypes[] | null,
    setAgentActivityMessageTypes: (value: agentActivityMessageTypes[]) => void,
    getAgentActivityMessageTypesApiCall: (channel_id: number) => Promise<CommonResponseModel<agentActivityMessageTypes>>,

    agentActivityMsgVariableTypes: agentActivityMessageVariableType[] | null,
    setAgentActivityMsgVariableTypes: (value: agentActivityMessageVariableType[]) => void,
    getAgentActivityMsgVariableTypesApiCall: () => Promise<CommonResponseModel<agentActivityMessageVariableType>>,

    flagOpenWabaVerificationForm: boolean,
    setFlagOpenWabaVerificationForm: (value: boolean) => void,

    wabaVerificationData: OrganizationWabaVerificationData | null,
    setWabaVerificationData: (value: OrganizationWabaVerificationData | null) => void,

    getWabaApprovalStatus: (organization_id: string) => Promise<any>,

    flagIntegrationNotAvailablePopup: boolean,
    setFlagIntegrationNotAvailablePopup: (value: boolean) => void,
}

export const useIntegrationStore = create<integrationStoreInterface>((set) => ({
    agentActivityMessageTypes: null,
    setAgentActivityMessageTypes: (value) => set({ agentActivityMessageTypes: value }),

    getAgentActivityMessageTypesApiCall: async (channel_id: number) => {
        const response = await agent.getAgentActivityMessageTypes.get(channel_id);
        if (response?.status) {
            set({ agentActivityMessageTypes: response?.data });
        }
        else {
            set({ agentActivityMessageTypes: null });
        }
        return response;
    },

    agentActivityMsgVariableTypes: null,
    setAgentActivityMsgVariableTypes: (value) => set({ agentActivityMsgVariableTypes: value }),

    getAgentActivityMsgVariableTypesApiCall: async () => {
        const response = await agent.getAgentActivityMessageVariableType.get();
        if (response?.status) {
            set({ agentActivityMsgVariableTypes: response?.data });
        }
        else {
            set({ agentActivityMsgVariableTypes: null });
        }
        return response;
    },

    flagOpenWabaVerificationForm: false,
    setFlagOpenWabaVerificationForm: (value: boolean) => set({ flagOpenWabaVerificationForm: value }),

    wabaVerificationData: null,
    setWabaVerificationData: (value: OrganizationWabaVerificationData | null) => set({ wabaVerificationData: value }),

    getWabaApprovalStatus: async (organization_id: string) => {
        const res = await agent.getWabaApprovalStatus.get(organization_id);

        if(res?.status){
            set({ wabaVerificationData: res?.data });
        } else {
            set({ wabaVerificationData: null });

        }
        return res;
    },

    flagIntegrationNotAvailablePopup: false,
    setFlagIntegrationNotAvailablePopup: (value: boolean) => set({ flagIntegrationNotAvailablePopup: value }),
}))
